import { IconBell } from "@tabler/icons-react";
import { clsx } from "clsx";
import { Text } from "../../../../components/common/typography";
import { formatRelativeTime } from "./dashboard-helpers";
import { EmptyRow } from "./empty-row";
import type { NotificationDto } from "../../../../api";

export function RecentNotificationsSection({
  notifications,
  onClickNotification,
}: {
  notifications: NotificationDto[];
  onClickNotification: (n: NotificationDto) => void;
}) {
  if (notifications.length === 0) {
    return <EmptyRow icon={IconBell} title="You're all caught up." />;
  }

  return (
    <>
      {notifications.map((n) => (
        <button
          key={n.id}
          type="button"
          onClick={() => onClickNotification(n)}
          className={clsx(
            "flex w-full items-start gap-3 rounded-xl px-3 py-3 text-left transition-colors hover:bg-bgLight",
            n.readAt === null && "bg-accentGreenTintBg",
          )}
        >
          <span
            className={clsx(
              "mt-2 size-2 shrink-0 rounded-full",
              n.readAt === null ? "bg-accentGreenDark" : "bg-transparent",
            )}
          />
          <div className="flex min-w-0 flex-1 flex-col gap-0.5">
            <Text variant="bodyBold" tone="dark" className="truncate">{n.title}</Text>
            <Text variant="bodySm" tone="muted" className="line-clamp-1">{n.body}</Text>
          </div>
          <Text variant="bodyXs" tone="muted" className="mt-0.5 shrink-0">
            {formatRelativeTime(n.createdAt)}
          </Text>
        </button>
      ))}
    </>
  );
}
